// Files

const mof = ['MOF.pdf'];

const ordenanzas = ['ORDENANZA MUNICIPAL N° 003-2024-MDLLP.pdf'];

const decretos = ['DECRETO DE ALCALDIA Nº 002-2025.pdf'];

const cuis = ['CUIS.pdf'];

const ras = ['RAS.pdf'];

const directivas = ['DIRECTIVA N 04-DIRECTIVA QUE ESTABLECE LINEAMIENTOS DE CONDUCTA.pdf'];

const organigrama = ['Organigrama.pdf', 'Organigrama 2024.pdf'];

const otros = [
  'ANEXO 04 - CUADRO MULTIANUAL DE NECESIDADES.pdf',
  'CREACION DEL DISTRITO DE PALLAN.pdf',
  'CUADRO DE NECESIDADES-2026.pdf',
  'CARTA MULTIPLE N 001-1.pdf',
  'EVALUACION DEL CUADRO MULTIANUAL DE NECESIDADES PRIMER SEMESTRE 2026.pdf',
];

const p_participativo_2025 = [
  'Decreto de Alcaldía.pdf',
  'Equipo Técnico.pdf',
  'Ordenanza Municipal.pdf',
  'Presupuesto Participativo 2025.pdf',
  'Proceso de Presupuesto Participativo 2025.pdf',
  'Relación de Agentes.pdf',
  'Solicitud de Registro de Agentes.pdf',
];

const presupuesto_2025 = [
  'PLAN DE DESARROLLO CONCERTADO.pdf',
  'SUBGERENCIA DE DESARROLLO SOCIAL.pdf',
  'SUBGERENCIA DE INFRAESTRCTURA.pdf',
  'TECHOS PRESUPUESTALES AÑO FISCAL 2025.pdf',
  'UNIDAD DE PLANIFICACION Y PRESUPUESTO.pdf',
];

const resoluciones_alcaldia_2024 = [
  'RESOLUCIÓN DE ALCALDÍA N° 25-2024-MDLLP.pdf',
];

const resoluciones_alcaldia_2025 = [
  'Resolucion de Alcaldia 01-2025.pdf',
  'Resolucion de Alcaldia 02-2025.pdf',
  'Resolucion de Alcaldia 03-2025.pdf',
  'Resolucion de Alcaldia 04-2025.pdf',
  'Resolucion de Alcaldia 06-2025.pdf',
  'Resolucion de Alcaldia 07-2025.pdf',
  'Resolucion de Alcaldia 08-2025.pdf',
  'Resolucion de Alcaldia 11-2025.pdf',
  'Resolucion de Alcaldia 12-2025.pdf',
  'Resolucion de Alcaldia 15-2025.pdf',
  'Resolucion de Alcaldia 16-2025.pdf',
  'Resolucion de Alcaldia 18-2025.pdf',
  'Resolucion de Alcaldia 20-2025.pdf',
  'Resolucion de Alcaldia 23-2025.pdf',
  'Resolucion de Alcaldia 24-2025.pdf',
  'Resolucion de Alcaldia 25-2025.pdf',
  'Resolucion de Alcaldia 27-2025.pdf',
  'Resolucion de Alcaldia 28-2025.pdf',
  'Resolucion de Alcaldia 29-2025.pdf',
  'Resolucion de Alcaldia 30-2025.pdf',
  'Resolucion de Alcaldia 31-2025.pdf',
  'Resolucion de Alcaldia 32-2025.pdf',
  'Resolucion de Alcaldia 33-2025.pdf',
  'Resolucion de Alcaldia 34-2025.pdf',
  'Resolucion de Alcaldia 35-2025.pdf',
  'Resolucion de Alcaldia 36-2025.pdf',
];

const rof = ['ROF.pdf', 'ROF 2024.pdf'];

const transferencia_de_partidas = [
  'TRANSFERENCIA DE PARTIDAS A FAVOR DE DIVERSOS GOBIERNOS LOCALES.pdf',
  'D.S N° 061-2024-EF 24.04.2024.pdf',
];

const tupa = ['TUPA.pdf'];

const audiencia_publica_2026 = [
  'ORDENANZA DE AUDIENCIA PÚBLICA.pdf',
  'REGLAMENTO DE AUDIENCIA PÚBLICA.pdf',
  'Anexos.docx',
  'Decreto Alcaldia Nº 002-2026.pdf',
  'PRIMERA AUDIENCIA DE ENERO A MAYO 2026.pdf',
];

const rendicion_de_cuentas_y_transferencia_de_gestion_2023_2026 = [
  'CONSTANCIA DE PRESENTACIÓN DEL INFORME DE RENDICIÓN DE CUENTAS DE TITULARES INICIAL.png',
  'INFORME RCT 2026 - ALCALDIA Y GERENCIA PORTAL INSTITUCIONAL.pdf',
];


// Map function - Generar rutas públicas accesibles
function createDocumentObject(folder) {
  return function (fileName) {
    // Usar rutas del directorio public que se incluyen en el build React
    // Esto funciona sin depender de servidor Express
    return {
      title: fileName,
      // Ruta de documentos que funciona en cualquier hosting (Apache, Nginx, etc)
      path: `/documents/${folder}/${fileName}`,
      target: '_blank',
    };
  };
}

// Documents

export const mofList = mof.map(createDocumentObject('mof'));

export const ordenanzasList = ordenanzas.map(
  createDocumentObject('ordenanzas')
);
export const decretosList = decretos.map(createDocumentObject('decretos'));

export const cuisList = cuis.map(createDocumentObject('cuis'));

export const rasList = ras.map(createDocumentObject('ras'));

export const directivasList = directivas.map(createDocumentObject('directivas'));

export const organigramaList = organigrama.map(
  createDocumentObject('organigrama')
);

export const otrosList = otros.map(createDocumentObject('otros'));

export const p_participativo_2025_List = p_participativo_2025.map(
  createDocumentObject('presupuesto-participativo-2025')
);

export const presupuesto_2025_List = presupuesto_2025.map(
  createDocumentObject('presupuesto-2025')
);

export const resoluciones_alcaldia_2024_List = resoluciones_alcaldia_2024.map(
  createDocumentObject('resoluciones/resoluciones-alcaldia-2024')
);

export const resoluciones_alcaldia_2025_List = resoluciones_alcaldia_2025.map(
  createDocumentObject('resoluciones/resoluciones-alcaldia-2025')
);

export const rofList = rof.map(createDocumentObject('rof'));

export const transferencia_de_partidasList = transferencia_de_partidas.map(
  createDocumentObject('transferencia-de-partidas')
);

export const tupaList = tupa.map(createDocumentObject('tupa'));

export const audiencia_publica_2026_List = audiencia_publica_2026.map(
  createDocumentObject('audiencia-publica-2026')
);

export const rendicion_de_cuentas_y_transferencia_de_gestion_2023_2026_List = rendicion_de_cuentas_y_transferencia_de_gestion_2023_2026.map(
  createDocumentObject('rendicion-de-cuentas-y-transferencia-de-gestion-2023-2026')
);

// Folders - Con URLs compartibles
export const muniFolders = [
  {
    title: 'MOF',
    path: '/municipalidad/instrumentos-de-gestion/mof',
  },
  {
    title: 'Ordenanzas',
    path: '/municipalidad/instrumentos-de-gestion/ordenanzas',
  },
  {
    title: 'Decretos',
    path: '/municipalidad/instrumentos-de-gestion/decretos',
  },
  {
    title: 'CUIS',
    path: '/municipalidad/instrumentos-de-gestion/cuis',
  },
  {
    title: 'RAS',
    path: '/municipalidad/instrumentos-de-gestion/ras',
  },
  {
    title: 'DIRECTIVAS',
    path: '/municipalidad/instrumentos-de-gestion/directivas',
  },
  {
    title: 'Organigrama',
    path: '/municipalidad/instrumentos-de-gestion/organigrama',
  },
  {
    title: 'Otros',
    path: '/municipalidad/instrumentos-de-gestion/otros',
  },
  {
    title: 'Presupuesto Participativo 2025',
    path: '/municipalidad/instrumentos-de-gestion/presupuesto-participativo-2025',
  },
  {
    title: 'Presupuesto 2025',
    path: '/municipalidad/instrumentos-de-gestion/presupuesto-2025',
  },
  {
    title: 'Resoluciones',
    path: '/municipalidad/instrumentos-de-gestion/resoluciones',
  },
  {
    title: 'ROF',
    path: '/municipalidad/instrumentos-de-gestion/rof',
  },
  {
    title: 'Transferencia de Partidas',
    path: '/municipalidad/instrumentos-de-gestion/transferencia-de-partidas',
  },
  {
    title: 'TUPA',
    path: '/municipalidad/instrumentos-de-gestion/tupa',
  },
  {
    title: 'Rendición de Cuentas y Transferencia de Gestión 2023-2026',
    path: '/municipalidad/instrumentos-de-gestion/rendicion-de-cuentas-y-transferencia-de-gestion-2023-2026',
  },
];

// Subcarpetas de Resoluciones
export const resolucionesFolders = [
  {
    title: 'Resoluciones de Alcaldía 2024',
    path: '/municipalidad/instrumentos-de-gestion/resoluciones/2024',
  },
  {
    title: 'Resoluciones de Alcaldía 2025',
    path: '/municipalidad/instrumentos-de-gestion/resoluciones/2025',
  },
];
